import Notes from "./Notes";

export default function Save({ showAlert }) {
  return <Notes showAlert={showAlert} />;
}
